import React from 'react';

/**
 * @param {Function} callback - function to debounce
 * @param {number} delay - milliseconds
 * @returns {Function}
 */

export const useDebounce = (callback, delay) => {
  const timeoutRef = React.useRef(null);

  return React.useCallback((...args) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      callback(...args);
    }, delay);
  }, [callback, delay]);
};
